export var Language;
(function (Language) {
    Language["EN"] = "en";
    Language["ES"] = "es";
})(Language = Language || (Language = {}));
export const LanguageLabels = (i18n) => ({
    [Language.EN]: i18n.t('english'),
    [Language.ES]: i18n.t('spanish')
});
